export default __webpack_public_path__ + "static/media/aboutgigmarket-img.23a6704c.png";